export const getUserPosition = (user) => {
  if (user.employee_role && user.employee_role.name) {
    const { employee_role } = user;
    return employee_role.name
  }

  return ""
} 